import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: 18, height: 18, viewBox: "0 0 64 64", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M52 29H12a3 3 0 1 0 0 6h40a3 3 0 1 0 0-6z" }));
export default SvgMinus;
